import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function emailOrPhoneRequired(control: AbstractControl): ValidationErrors | null {
  const email = control.get('eMail')?.value as string;
  const phone = control.get('phoneNumber')?.value as string;

  if (!email && !phone) {
    control.get('eMail').setErrors({ required: true });
    control.get('phoneNumber').setErrors({ required: true });
    return { emailOrPhoneRequired: true };
  }

  if (email) {
    if (Validators.email(control.get('eMail'))) {
      control.get('eMail').setErrors({ email: true });
      return { emailInvalid: true };
    } else {
      control.get('eMail').setErrors(null);
    }
  }

  control.get('eMail').setErrors(null);
  control.get('phoneNumber').setErrors(null);
  return null;
}
